import { fetcher } from '../../../fetcher';
import { getFileInformation } from '../../../image-validations/helpers';
import { GlovoMediaError } from '../../../types';
export const uploadImageToProvider = async (file, options) => {
    try {
        const formData = new FormData();
        formData.append('file', file, file.name);
        if (options.entity) {
            formData.append('entity', options.entity);
        }
        const response = await fetcher.post(options.apiConfig.url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: options.apiConfig.authToken,
            },
        });
        return { success: true, data: response.data };
    }
    catch (err) {
        const fileInformation = await getFileInformation(file);
        throw new GlovoMediaError(`Something went wrong, try again`, err, fileInformation);
    }
};
export const uploadImageUrlToProvider = async (url, options) => {
    const payload = {
        url,
        ...(options.entity && { entity: options.entity }),
    };
    try {
        const response = await fetcher.post(options.apiConfig.url, payload, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: options.apiConfig.authToken,
            },
        });
        return { success: true, data: response.data };
    }
    catch (err) {
        throw new GlovoMediaError('Something went wrong, try again', err, undefined);
    }
};
//# sourceMappingURL=upload-api.js.map